import { firstValueFrom } from 'rxjs';
import {
  DischargeInfo,
  DischargeInfoDto,
  RequestDto,
} from '../models/request.dto';
import { AuthService } from '../services/auth.service';
import { RequestService } from '../services/request.service';
import { FormDto } from '../models/form.dto';
import { AttachmentService } from '../services/attachment.service';

export async function handlePostAcuziePreSave(
  api: any,
  request: RequestDto,
  requestDates: DischargeInfo[],
    services: { requestService: RequestService; authService: AuthService; attachmentService: AttachmentService },
    form: FormDto,
    compositionId: string,
) {
  const dischargeDate = api?.getFieldValue(
    'modulo_segnalazione_post_acuzie/modulo_richiesta_posto_letto_per_trasferimento_in_medicina_riabilitativa_intensiva_e_lungodegenza/sintesi_clinica/data_di_presunta_dimissione'
  );

  const intensiva = api?.getFieldModel(
    'modulo_segnalazione_post_acuzie/modulo_richiesta_posto_letto_per_trasferimento_in_medicina_riabilitativa_intensiva_e_lungodegenza/setting_indicato_in_consulenza_fisiatrica/riabilitativa_intensiva'
  )?.value[0]?.value;

  const lunga = api?.getFieldModel(
    'modulo_segnalazione_post_acuzie/modulo_richiesta_posto_letto_per_trasferimento_in_medicina_riabilitativa_intensiva_e_lungodegenza/setting_indicato_in_consulenza_fisiatrica/lungodegenza'
  )?.value[0]?.value;
  let subsetting = null;
  if(intensiva?.length) {
    subsetting = intensiva;
  } else if (lunga?.length) {
    subsetting = lunga;
  }

  if(subsetting?.length) {
    await firstValueFrom(services.requestService.changeSetting(request.id, subsetting));
  }

  let payload: DischargeInfoDto = {
    date: dischargeDate+'T00:00:00',
    operatorCode: services.authService.userInfo.username,
    transitionId: request.id,
    typeId: 1,
  };

  if(dischargeDate) {
    if (requestDates && requestDates.find((d) => d.dateType?.code == 'DDP')) {
      payload.id = requestDates.find((d) => d.dateType?.code == 'DDP')?.id;
      await firstValueFrom(services.requestService.updateDischargeInfo(payload));
    } else {
      await firstValueFrom(services.requestService.createDischargeInfo(payload));
    }
  }

  const attachmentCode = api?.getFieldModel(
    'modulo_segnalazione_post_acuzie/modulo_richiesta_posto_letto_per_trasferimento_in_medicina_riabilitativa_intensiva_e_lungodegenza/consulenza_fisiatrica/documentazione_fisicatrica_string'
  )?.value[0]?.label;

  const fileName = api?.getFieldModel(
    'modulo_segnalazione_post_acuzie/modulo_richiesta_posto_letto_per_trasferimento_in_medicina_riabilitativa_intensiva_e_lungodegenza/consulenza_fisiatrica/nome_allegato'
  )?.value[0];

  const fileContentType = api?.getFieldModel(
    'modulo_segnalazione_post_acuzie/modulo_richiesta_posto_letto_per_trasferimento_in_medicina_riabilitativa_intensiva_e_lungodegenza/consulenza_fisiatrica/estensione_allegato'
  )?.value[0];

  const fileuuid = api?.getFieldModel(
    'modulo_segnalazione_post_acuzie/modulo_richiesta_posto_letto_per_trasferimento_in_medicina_riabilitativa_intensiva_e_lungodegenza/consulenza_fisiatrica/uuid'
  )?.value[0];


  let requestAttachment = {
    transitionUuid: request.uuid,
    attachmentCode: attachmentCode,
    formId: form.id,
    compositionId: form.compositionId ? form.compositionId : compositionId,
    fileName: fileName,
    fileContentType: fileContentType,
    fileUuid: fileuuid
  }

  await firstValueFrom(
        services.attachmentService.insertAttachmentFromForm(requestAttachment)
      );
}
